module.exports = __webpack_public_path__ + "ai.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/ai.svg
// module id = 411
// module chunks = 0